import { Link } from 'react-router-dom';
import { cn } from '../lib/utils';

export function ListingCard({ to, index, cardClass, stub, children, testId, onClick, current = false }) {
  return (
    <Link
      to={to}
      aria-current={current ? 'page' : undefined}
      className="block ticket-enter"
      style={{ animationDelay: `${index * 50}ms` }}
      data-testid={testId}
      onClick={onClick}
    >
      {/* card-press is what answers the tap. Opening a request unmounts this list and mounts
          the detail screen, and measured on a throttled phone nothing repainted for 158ms in
          production and 339ms against the dev server — long enough that the tap read as
          ignored. The press is pure CSS on :active, so it paints on the next frame, before
          React has begun the swap. */}
      <div className={cn('s8-card s8-glow-border card-press', cardClass)}>
        {stub && (
          <>
            <div className="s8-card-stub">{stub}</div>
            <div className="s8-card-sep">
              <div className="s8-card-sep-line" />
            </div>
          </>
        )}
        <div className="s8-card-body">{children}</div>
      </div>
    </Link>
  );
}

export function CardRow({ children, className }) {
  return <div className={cn('s8-row', className)}>{children}</div>;
}

export function CardTitle({ children }) {
  return <h3 className="s8-title">{children}</h3>;
}

export function CardPrice({ amount, sub }) {
  return (
    <span className="s8-price shrink-0">
      {amount || 'On request'}
      {amount && sub && <span className="s8-price-sub">{sub}</span>}
    </span>
  );
}

export function CardDivider() {
  return <div className="s8-card-hr" />;
}

export function CardTags({ children }) {
  return <div className="s8-tags">{children}</div>;
}

export function CardMetric({ children }) {
  return <span className="s8-metric">{children}</span>;
}
